import React from "react";
import classNames from "classnames/bind";

import { Screen } from "components/Screen";

import styles from "./Agreement.module.css";
import { useStateManager } from "utils/useStateManager";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: () => void;
};

export const Agreement: React.FC<Props> = (props) => {
  const { linkInfo } = useStateManager();

  return (
    <Screen
      title="О персональных данных"
      buttonTitle="Подтверждаю согласие"
      onSubmit={props.onSubmit}
    >
      <div className={cx("inner")}>
        <div className={cx("title")}>
          <span>Уважаемый пользователь,</span>
          <br />
          <span>
            в соответствии с ФЗ №152 мы обязаны получить с вас согласие на
            обработку персональных данных. Полный текст согласия ниже.
          </span>
        </div>
        {linkInfo && (
          <div
            className={cx("text")}
            dangerouslySetInnerHTML={{
              __html: linkInfo?.consent,
            }}
          />
        )}
      </div>
    </Screen>
  );
};
